import { IGameAnswer } from '../data/question'

const wasFullyCorrectAnswered = (correctAnswers: IGameAnswer[], selectedAnswersIDs: string[] | null) => {
	//TODO: Evaluate replacing this frontend computation for just getting a backend value, look: this.props.playerData.view.payload

	//if the number of necessaries answer was already selected
	if ((correctAnswers && correctAnswers.length) === (selectedAnswersIDs && selectedAnswersIDs.length)) {
		const correctAnswersSelectedByStudent = correctAnswers.filter(
			(correctAnswer: IGameAnswer) => selectedAnswersIDs && selectedAnswersIDs.includes(correctAnswer.uid)
		)
		return (correctAnswersSelectedByStudent && correctAnswersSelectedByStudent.length) === correctAnswers.length
	}

	return false
}

export default wasFullyCorrectAnswered
